// src/contexts/controleBar/mesas/MesaConfContext.js
import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { fetchData, postData, putData, deleteData } from '../../../services/Api';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';
import MesaConfCad from '../../../pages/controleBar/mesas/MesaConfCad'; 
import MesaConfSearch from '../../../pages/controleBar/mesas/MesaConfSearch';

const MesaConfContext = createContext();

export const useMesaConf = () => useContext(MesaConfContext);

export const MesaConfProvider = ({ children }) => {
  const [mesasConf, setMesasConf] = useState([]);
  const [mesaConfSel, setMesaConfSel] = useState(null);
  const { showAlert } = useAlert();
  const { showMessage } = useMessage();

  // Modal Search
  const [showSearchMesaConf, setShowSearchMesaConf] = useState(false);
  const tempOnSelectMesaConfRef = useRef(null);

  const handleShowMesaConfSearch = () => {
    return new Promise((resolve) => {
      setShowSearchMesaConf(true);
      const handleSelect = (mesaSelect) => {
        setShowSearchMesaConf(false);
        resolve(mesaSelect || null);
      };
      tempOnSelectMesaConfRef.current = handleSelect;
    });
  };
  const handleCloseSearchModal = () => {
    setShowSearchMesaConf(false);
    tempOnSelectMesaConfRef.current = null;
  };

  // Modal Cad
  const [showCadMesaConf, setShowCadMesaConf] = useState(false);
  const showMesaConfCad = () => setShowCadMesaConf(true);
  const handleSelectMesaConfSearch = (mesaSelect) => {
    tempOnSelectMesaConfRef.current?.(mesaSelect);
  };

  // CRUD
  const fetchMesasConf = useCallback(async () => {
    try {
      const result = await fetchData('/MesaConf');
      setMesasConf(result);
    } catch (error) {
      console.error('Erro ao buscar mesas config:', error);
      showMessage(`Erro ao buscar configurações de mesa! ${error?.message || error}`, 'danger');
    }
  }, [showMessage]);

  useEffect(() => {
    fetchMesasConf();
  }, [fetchMesasConf]);

  const addMesaConf = async (mesaConf) => {
    try {
      const result = await postData('/MesaConf', mesaConf);
      setMesasConf(prev => [...prev, result]);
      showAlert('Configuração de mesa adicionada com sucesso!');
    } catch (error) {
      console.error('Erro ao adicionar configuração de mesa:', error);
      showMessage('Erro ao adicionar configuração de mesa!\n' + error, 'danger');
    }
  };

  const updateMesaConf = async (mesaConf) => {
    try {
      const result = await putData('/MesaConf', mesaConf);
      setMesasConf(prev => prev.map(m => (m.id === result.id ? result : m)));
      showAlert('Configuração de mesa alterada com sucesso!');
    } catch (error) {
      console.error('Erro ao atualizar configuração de mesa:', error);
      showAlert('Erro ao alterar configuração de mesa!', 'danger');
    }
  };

  const deleteMesaConf = async (id) => {
    try {
      await deleteData('/MesaConf', { mesaConfId: id });
      setMesasConf(prev => prev.filter(m => m.id !== id));
      showAlert('Configuração de mesa excluída com sucesso!');
    } catch (error) {
      console.error('Erro ao excluir configuração de mesa:', error);
      showAlert('Erro ao excluir configuração de mesa!', 'danger');
    }
  };

  return (
    <MesaConfContext.Provider value={{
      mesasConf,
      mesaConfSel,
      setMesaConfSel,
      addMesaConf,
      updateMesaConf,
      deleteMesaConf,
      fetchMesasConf,
      handleShowMesaConfSearch,
      showMesaConfCad
    }}>
      {children}

      <MesaConfSearch
        show={showSearchMesaConf}
        onHide={handleCloseSearchModal}
        onSelectMesaConf={handleSelectMesaConfSearch}
      />
      <MesaConfCad
        show={showCadMesaConf}
        onHide={() => setShowCadMesaConf(false)}
      />
    </MesaConfContext.Provider>
  );
};
